import type { DeepPartial } from '@luna/utils-ts';
import type { ExportFeatureConfig, TransactionsFeatureConfig } from '@shared/transactions-config';
import { isFeatureEnabled } from '@luna/gatekeeper';

const shouldShowFavoriteField = (): boolean => isFeatureEnabled((f) => f.transactions.favorites);

export const transactions: DeepPartial<TransactionsFeatureConfig> = {
    showOriginator: true,
    showOriginatorDirectlyFromApi: true,
    searchForAmountInFulltextMode: false,
};

export const exportFeatures: DeepPartial<ExportFeatureConfig> = {
    fields: [
        { name: 'ownerAccountTitle', preselected: true, selectable: true },
        { name: 'ownerAccountNumber', preselected: true, selectable: true },
        { name: 'booking', preselected: true, selectable: true },
        { name: 'receiver', preselected: true, selectable: true },
        { name: 'amount', preselected: true, selectable: true },
        { name: 'currency', preselected: true, selectable: true },
        { name: 'reference', preselected: true, selectable: true },
        { name: 'referenceNumber', preselected: false, selectable: true },
        { name: 'note', preselected: false, selectable: true },
        {
            name: 'favorite',
            condition: shouldShowFavoriteField,
            preselected: false,
            selectable: true,
        },
        { name: 'valuation', preselected: false, selectable: true },
        { name: 'receiverReference', preselected: false, selectable: true },
        { name: 'sepaMandateId', preselected: false, selectable: true },
        { name: 'sepaCreditorId', preselected: false, selectable: true },
        { name: 'virtualCardNumber', preselected: false, selectable: true },
        { name: 'virtualCardDevice', preselected: false, selectable: true },
        { name: 'aliasPay', preselected: true, selectable: true },
        { name: 'senderReference', preselected: false, selectable: true },
        { name: 'senderIdentificationReference', preselected: false, selectable: true },
    ],
    sortParams: ['BOOKING_DATE_ASC', 'BOOKING_DATE_DESC', 'AMOUNT_ASC', 'AMOUNT_DESC'],
};
